import {
  getShipmentInfoFromStops,
  stopRenderer,
  warningRenderer,
  getJourneyPallets,
  convertCMtoMeters,
} from '../utils';

const UK_Assignation_template = (journey) => {
  const { stops, extras, item_height, id, net_full_cost, max_weight } = journey;

  const country = 'UK';
  const totalPallets = getJourneyPallets(journey, country);
  const stopsInfo = getShipmentInfoFromStops(stops, country);
  const stopsToRender = stopRenderer(stops, country).join('');
  const warning = warningRenderer(extras, country);
  const totalHeight = convertCMtoMeters(item_height);

  return `
  The job is yours
  Reference Number: ${id}

  ${totalPallets}
  ${totalHeight}m - Total Height
  ${max_weight} Kg - Maximum Weight

  ${stopsInfo.shipmentType}
  ${stopsInfo.PICKUP} Collection(s), ${stopsInfo.DROPOFF} Drop off(s)
  ${stopsToRender}
  ${warning}

  Amount you earn: £ ${net_full_cost} + VAT
  `;
};

export default UK_Assignation_template;
